import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { useI18n } from "@/context/I18nContext";
import { Bell, CheckCheck, Info, CheckCircle2 } from "lucide-react";

const KIND_STYLE = {
  success: { icon: CheckCircle2, color: "#22c55e" },
  info: { icon: Info, color: "#EAB308" },
};

export default function NotificationsPage() {
  const { t } = useI18n();
  const [notifs, setNotifs] = useState([]);

  const load = () => api.get("/notifications").then(({ data }) => setNotifs(data)).catch(() => {});

  useEffect(() => { load(); }, []);

  const markRead = async (id) => {
    await api.patch(`/notifications/${id}/read`);
    setNotifs((ns) => ns.map((n) => (n.id === id ? { ...n, read: true } : n)));
  };

  return (
    <div className="space-y-8" data-testid="notifications-page">
      <div>
        <h1 className="text-3xl font-extrabold text-white">{t("dash.pages.notif.title")}</h1>
        <p className="mt-1 text-white/55">{t("dash.pages.notif.desc")}</p>
      </div>

      <div className="space-y-3">
        {notifs.length === 0 && (
          <div className="rounded-lg border border-white/10 bg-[#0a0a0a] p-10 text-center text-white/40">
            <Bell className="w-8 h-8 mx-auto mb-3 opacity-40" />
            {t("dash.pages.notif.empty")}
          </div>
        )}
        {notifs.map((n) => {
          const s = KIND_STYLE[n.kind] || KIND_STYLE.info;
          const Icon = s.icon;
          return (
            <div
              key={n.id}
              data-testid="notification-item"
              className={`flex items-start gap-4 rounded-lg border p-5 transition-colors ${
                n.read ? "border-white/8 bg-[#080808]" : "border-[#EAB308]/25 bg-[#0a0a0a]"
              }`}
            >
              <div className="mt-0.5 flex h-9 w-9 items-center justify-center rounded-md shrink-0" style={{ background: `${s.color}18`, border: `1px solid ${s.color}33` }}>
                <Icon className="w-4 h-4" style={{ color: s.color }} />
              </div>
              <div className="min-w-0 flex-1">
                <div className="font-semibold text-white">{n.title}</div>
                <p className="text-sm text-white/55 mt-0.5">{n.body}</p>
              </div>
              {!n.read && (
                <button
                  onClick={() => markRead(n.id)}
                  data-testid={`mark-read-${n.id}`}
                  className="shrink-0 flex items-center gap-1.5 text-xs text-[#EAB308] hover:underline"
                >
                  <CheckCheck className="w-4 h-4" /> {t("dash.pages.notif.markRead")}
                </button>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
